var _defs, _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510 510",
    width: 510,
    height: 510,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "polygon-logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.5 110.3h333.1v291.9h-333.1z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #8247e5 } \n\t\t.s1 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m254.8 0.4c140.4 0 254.2 113.8 254.2 254.2 0 140.4-113.8 254.1-254.1 254.1-140.4 0-254.1-113.8-254.1-254.1-0.1-140.4 113.7-254.2 254-254.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m408.4 240.2c6.9 4.4 10.4 11.3 10.4 18.3v82.8c0 7.8-4.3 14.8-10.4 18.3l-70.3 41c-6.9 3.5-14.7 3.5-20.8 0l-70.3-41c-6.9-4.4-10.4-11.3-10.4-18.3v-28.8l33-19.2v27.9c0 7.8 4.3 14.8 10.4 18.3l37.4 21.8c6.9 3.5 14.7 3.5 20.8 0l36.4-21.8c6.9-4.4 10.4-11.3 10.4-18.3v-43.6c0-7.8-4.3-14.8-10.4-18.3l-37.3-21.8c-6.9-3.5-14.7-3.5-20.8 0l-47.7 27.9-33 19.2-47.7 27.9c-6.9 3.5-14.7 3.5-20.8 0l-70.3-41c-6.9-4.4-10.4-11.3-10.4-18.3v-81.9c0-6.9 3.5-13.9 10.4-17.4l71.1-41.9c6.9-3.5 14.7-3.5 20.8 0l69.4 41c6.9 4.4 10.4 11.3 10.4 18.3v29.6l-33 19.2v-28.8c0-7.8-4.3-14.8-10.4-18.3l-37.3-22.7c-6.9-3.5-14.7-3.5-20.8 0l-37.3 21.8c-6.9 4.4-10.4 11.3-10.4 18.3v43.6c0 7.8 4.3 14.8 10.4 18.3l37.3 22.7c6.9 3.5 14.7 3.5 20.8 0l47.7-28.7 33-18.3 48.6-28.8c6.9-3.5 14.7-3.5 20.8 0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonLogo);
export default __webpack_public_path__ + "static/media/polygon-logo.43892668eb87dd1101979d9210d1569c.svg";
export { ForwardRef as ReactComponent };